import React from 'react';
import agent from '../../agent';
import { connect } from 'react-redux';
import SiteList from './SiteList';
import RecentSites from './RecentSites';
import { SITE_SUBMITTED } from '../../constants/actionTypes';

const mapStateToProps = state => ({
  templates: state.templates,
  token: state.common.token,
  sites: state.sites || []
});

const mapDispatchToProps = dispatch => ({
  submitSite: payload =>
    dispatch({ type: SITE_SUBMITTED, payload }),
});

class Sites extends React.Component {
  render() {
    return (
      <div className="container page">
        <div className="row">
          <SiteList 
            token={this.props.token}
            sites={this.props.sites}/>

          <RecentSites 
            token={this.props.token}
            sites={this.props.sites}/>

        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sites);
